<template>
  <div id="app">
    <div class="header">
      <div class="bg-img">
        <!-- <img src="../../images/store-bg.png"> -->
      </div>
      <a href="javascript:history.back();" class="arrow" :class="{ istop: isShow }"><i class="iconfont icon-arrow-left" /></a>
      <div class="shop">
        <div class="logo">
          <img :src="brand.brandLogo">
        </div>
        <span class="van-ellipsis">{{ brand.brandName }}</span>
        <a :href="brandHomeUrl" :tjjj="tjjjPrefix + 'brand'">逛品牌</a>
      </div>
      <div class="form shadow">
        <Reservation :brand-id="brand.brandId" :tjjj-prefix="tjjjPrefix" @get-location-success="_getLocationSuccess" @get-location-failed="_getLocationFailed" />
      </div>
    </div>
    <div class="list">
      <nav v-if="showListFilter" class="list-filter" :class="{ fixed: fixFilter }">
        <div class="filter" :class="{ open: locationOpened }" @click="tapLocation">{{ selectedCity }}<i class="iconfont icon-arrow-down" :class="{ open: locationOpened }" /></div>
        <div class="filter" :class="{ open: sortOpened }">{{ selectedSort }}</div>
        <!-- <div class="filter" :class="{ open: sortOpened }" @click="tapSort">{{ selectedSort }}<i class="iconfont icon-arrow-down" :class="{ open: sortOpened }" /></div> -->
      </nav>
      <div class="filter-popup" :class="{ fixed: fixFilter }">
        <div class="filter-wrapper" :style="{ height: locationHeight }">
          <van-list class="filter">
            <div v-for="(item, index) in cityList" :key="item.substationPy" class="filter-item" :class="{ selected: item.selected }" @click.stop="selectCity(index)">{{ item.substationCn }}</div>
          </van-list>
        </div>
        <div class="filter-wrapper" :style="{ height: sortHeight }">
          <van-list class="filter">
            <div v-for="(sort, index) in sortList" :key="sort.method" class="filter-item" :class="{ selected: sort.selected }" @click.stop="selectSort(index)">{{ sort.name }}</div>
          </van-list>
        </div>
      </div>
      <van-list v-model="loading" :finished="finished" :offset="loadOffset" class="result-list" :style="{ 'min-height': listMinHeight }" @load="_loadNext">
        <ShopListItem v-for="shop in shopList" :key="shop.shopId" :shop="shop" />
      </van-list>
      <div class="popmask" :style="{ height: popmaskHeight }" @click.capture="closeFilter" @touchmove.prevent.stop @scroll.native.prevent.stop />
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import axios from 'axios';
import { List, Popup, Toast } from 'vant';
import { isApp } from '@/lib/compatibility';
import Util from '../../lib/util';
import { on } from '../../lib/event';
import ShopListItem from '../../components/ShopListItem.vue';
import Reservation from '../../components/Reservation.vue';
import nativeBrandIndex from '../../filters/nativeBrandIndex';

Vue.use(List).use(Popup).use(Toast);

export default {
  name: 'App',
  components: {
    ShopListItem,
    Reservation,
  },
  data() {
    return {
      brand: globalData,
      shopList: [],
      cityList: [],
      sortList: [
        // { method: '', name: '智能筛选', selected: true },
        { method: 'BZ_DISTANCE', name: '离我最近', selected: true },
        // { method: 'BZ_EVALUATION', name: '评论最多', selected: false },
      ],
      locationOpened: false,
      sortOpened: false,
      fixFilter: false,
      loading: false,
      finished: false,
      loaded: false,
      city: '上海',
      cityPy: 'shanghai',
      sortBy: '',
      lat: 31.230416,
      lng: 121.473701,
      loadOffset: 100,
      currentPage: 0,
      totalPage: 0,
      showArrow: true,
      isShow: false,
      showListFilter: true,
    };
  },
  computed: {
    brandHomeUrl() {
      return nativeBrandIndex(`${globalRootUrl}ppzq/brand-${this.brand.brandId}/`);
    },
    selectedCity() {
      const selected = this.cityList.filter(city => city.selected);
      return selected[0] ? selected[0].substationCn : '请选择城市';
    },
    selectedSort() {
      const selected = this.sortList.filter(sort => sort.selected);
      return selected[0] ? selected[0].name : '请选择筛选方式';
    },
    filterOpened() {
      return this.locationOpened || this.sortOpened;
    },
    listMinHeight() {
      return `${(Math.min(Math.max(this.cityList.length, this.sortList.length), 8) + 0.7) * Util.px2rem(80)}rem`;
    },
    locationHeight() {
      if (this.locationOpened) return `${((this.cityList.length > 8 ? 8 : this.cityList.length) + 0.7) * Util.px2rem(80)}rem`;
      return 0;
    },
    sortHeight() {
      if (this.sortOpened) return `${(this.sortList.length + 0.7) * Util.px2rem(80)}rem`;
      return 0;
    },
    popmaskHeight() {
      return `${this.filterOpened ? Util.docpx2rem(document.body.clientHeight - this.filterTop) : 0}rem`;
    },
    tjjjPrefix() {
      return `click_m_brands_wangpu_${this.brand.brandPinyin}_`;
    },
  },
  watch: {
    loading(val) {
      if (val) {
        Toast.loading({
          duration: 0,
          mask: this.loaded,
          forbidClick: true,
          message: '加载中...',
        });
      } else {
        Toast.clear();
      }
    },
  },
  mounted() {
    this.loadOffset = Util.px2docpx(100);
    this._initAutoFix();
    if (isApp || window.location.host === 'h5.m.jia.com' || navigator.userAgent.match(/QIJIA/i) || navigator.userAgent.match(/MicroMessenger/i) || window.location.host === 'zixun.m.jia.com' || typeof (Device) !== 'undefined' || window.location.host === 'zm.jia.com' || window.location.host === 'baidu.m.jia.com') {
      this.showArrow = false;
      this.isShow = true;
    }
  },
  methods: {
    _initAutoFix() {
      this.filterTop = document.getElementsByClassName('list')[0].offsetTop;
      on(window, 'scroll', () => {
        const scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
        this.fixFilter = scrollTop >= this.filterTop;
      }, true);
    },

    tapLocation() {
      this.sortOpened = false;
      this.locationOpened = !this.locationOpened;
    },

    // tapSort() {
    //   this.locationOpened = false;
    //   this.sortOpened = !this.sortOpened;
    // },

    _getLocationSuccess(result) {
      this.city = result.city;
      this.cityPy = result.cityPy;
      this.lat = result.lat;
      this.lng = result.lng;
      this._loadNext(true);
    },

    _getLocationFailed() {
      this._loadNext(true);
    },

    _loadNext(reset = false) {
      if (this.filterOpened || (!reset && this.currentPage >= this.totalPage)) {
        this.loading = false;
        return;
      }
      if (reset) {
        this.currentPage = 0;
        this.totalPage = 0;
        this.shopList = [];
        this.finished = false;
        this.fixFilter = false;
        window.scrollTo(0, document.querySelector('.list').offsetTop);
      }
      const page = this.currentPage + 1;
      this.loading = true;
      axios.post(`${globalRootUrl}brandzone/search-shops`, {
        city: this.city,
        orderBy: this.sortBy,
        masterShopId: this.brand.linkedShop,
        lat: this.lat,
        lng: this.lng,
        page,
        pageSize: 10,
      })
        .then((res) => {
          if (res.data.substationList && res.data.substationList.length > 0) {
            this.cityList = res.data.substationList.map(item => Object.assign({}, item, { selected: item.substationCn === this.city }));
          } else {
            this.cityList = [];
          }
          if (res.data.moreShopResultList && res.data.moreShopResultList.length > 0) {
            this.shopList.push(...Util.complementImageUrl(res.data.moreShopResultList, 'logoUrl'));
          } else {
            this.showListFilter = false;
          }
          this.totalPage = res.data.totalPageCount;
          this.currentPage = res.data.currentPageNo;
          this.loading = false;
          this.loaded = true;
          if (this.currentPage >= this.totalPage) this.finished = true;
        })
        .catch((err) => {
          console.warn(err);
          this.loading = false;
          this.finished = true;
          this.loaded = true;
          Toast('加载店铺失败');
        });
    },

    closeFilter() {
      this.locationOpened = false;
      this.sortOpened = false;
    },

    selectCity(index) {
      this.closeFilter();
      this.cityList.forEach((city) => {
        city.selected = false;
      });
      this.cityList[index].selected = true;
      if (this.city !== this.cityList[index].substationCn) {
        this.city = this.cityList[index].substationCn;
        this.cityPy = this.cityList[index].substationPy;
        this._loadNext(true);
      }
    },

    selectSort(index) {
      this.closeFilter();
      this.sortList.forEach((sort) => {
        sort.selected = false;
      });
      this.sortList[index].selected = true;
      this.sortBy = this.sortList[index].method;
      this._loadNext(true);
    },
  },
};
</script>

<style lang="less">
@import (reference) "../../style/font.less";
@import "../../style/common.less";

.menu-box-shadow() {
  box-shadow: 0 0 10px 0 #eee;
}

.header {
  position: relative;
  width: 100%;
  overflow: hidden;

  .bg-img {
    position: absolute;
    left: 0;
    top: 0;
    width: 750px;
    height: 430px;
    overflow: hidden;
    z-index: -1;
    background: @white;
    background: url('../../images/store-bg.png') no-repeat;
    background-size: 100% auto;

    // img {
    //   width: 100%;
    //   height: 100%;
    // }

    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      height: 128px;
      background: linear-gradient(to top, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.5) 70%, rgba(0, 0, 0, 0.5));
      opacity: 0.6;
      filter: blur(4px);
    }
  }

  .arrow {
    display: inline-block;
    margin: 30px 12px;

    &.istop {
      transform: translateX(-100px);
    }

    .iconfont {
      color: @white;
      font-size: 50px;
    }
  }

  .shop {
    padding: 0 50px 0 28px;
    display: flex;
    align-items: center;

    .logo {
      flex: none;
      width: 150px;
      height: 75px;
      border-radius: 10px;
      background: @white;
      margin-right: 20px;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 128px;
        height: 64px;
      }
    }

    span {
      flex: 1;
      color: @black;
      font-weight: 500 !important;
      .font-page-title();
    }

    a {
      flex: none;
      width: 138px;
      height: 52px;
      line-height: 52px;
      border: none;
      border-radius: 26px;
      .font-small();
      .common-button-style();
    }
  }

  .form {
    margin: 60px 28px;
    border-radius: 20px;
    background: @white;
    padding: 5px 35px;
    box-sizing: border-box;
  }
}

.list {
  position: relative;
  width: 100%;
  background: @white;

  .list-filter {
    position: absolute;
    top: 0;
    background: @white;
    width: 100%;
    z-index: 100;
    border-bottom: 1px solid @lightgrey;
    display: flex;

    .filter {
      flex: 1;
      text-align: center;
      line-height: 80px;
      color: @black;
      .font-normal();

      &.open {
        color: @red;
      }

      .icon-arrow-down::before {
        margin-left: 6px;
        transition: transform 0.3s;
        display: inline-block;
        .font-normal();
      }

      .icon-arrow-down.open::before {
        transform: rotate(180deg);
      }
    }

    &.fixed {
      position: fixed;
      left: 0;
      top: 0;
      z-index: 300;
      .menu-box-shadow();
    }
  }

  .filter-popup {
    position: absolute;
    top: 85px;
    width: 100%;
    height: 0;
    z-index: 100;
    .menu-box-shadow();

    .filter-wrapper {
      position: absolute;
      top: 0;
      width: 100%;
      height: 0;
      background: @white;
      overflow-y: scroll;
      box-sizing: content-box;
      transition: height 0.3s;

      .filter {
        padding: 28px 60px;

        .filter-item {
          line-height: 80px;
          color: @black;
          .font-menu();

          &.selected {
            color: @red;
          }
        }
      }
    }

    &.fixed {
      position: fixed;
      left: 0;
      z-index: 300;
    }
  }

  .result-list {
    padding-top: 84px;
  }

  .popmask {
    position: absolute;
    display: block;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 97;
    background: rgba(0, 0, 0, 0.4);
  }
}
</style>
